export const tryJSONParse = <T>(data?: string): T | null => {
  if (!data) return null;
  try {
    return JSON.parse(data);
  } catch {
    return null;
  }
};

export const tryJSONStringify = (data: unknown): string => {
  if (!data) return '';
  try {
    return JSON.stringify(data) ?? '';
  } catch {
    return '';
  }
};

export const hexToRGB: (hex: string, alpha?: number) => string = (
  hex,
  alpha
) => {
  const cleanHex = hex.replace(/ /g, '');
  const r = parseInt(cleanHex.slice(1, 3), 16) || 0;
  const g = parseInt(cleanHex.slice(3, 5), 16) || 0;
  const b = parseInt(cleanHex.slice(5, 7), 16) || 0;
  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  return `rgb(${r}, ${g}, ${b})`;
};

export const stringToUniqueNumber = (text: string): number => {
  return text
    .split('')
    .reduce((total, value) => value.charCodeAt(0) + ((total << 5) - total), 0); // eslint-disable-line no-bitwise
};
